import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { connect } from 'react-redux';
import classNames from 'classnames';

import {
  switchTab,
  setChosenLocationNames,
  setCurrentState,
  toggleDrawer
} from '../../actions';

const mapDispatchToProps = dispatch => {
  return {
    setCurrentTab: id => dispatch(switchTab(id)),
    setLocationNames: names => dispatch(setChosenLocationNames(names)),
    mutateState: state => dispatch(setCurrentState(state)),
    setDrawer: () => dispatch(toggleDrawer())
  };
};

class Header extends Component {
  static propTypes = {
    setDrawer: PropTypes.func,
    t: PropTypes.func,
    i18n: PropTypes.object,
    router: PropTypes.object,
    setCurrentTab: PropTypes.func,
    setLocationNames: PropTypes.func,
    mutateState: PropTypes.func
  };

  clickHandle = () => {
    const { router, setCurrentTab, setLocationNames, mutateState } = this.props;

    setCurrentTab(0);
    setLocationNames([]);
    mutateState(null);

    return router.push('/');
  };

  render() {
    const { setDrawer, t, router } = this.props;
    const headerClassnames = classNames('header', {
      'header--fixed': router?.pathname === '/[...search]'
    });
    return (
      <div className={headerClassnames} id="header">
        <div className="header-top">
          <div
            className="open-drawer"
            data-cy="burger-menu"
            onClick={setDrawer}
            onKeyPress={setDrawer}
            role="button"
            tabIndex="-1"
          />
          <a
            className="header-logo"
            data-cy="header-logo"
            onClick={this.clickHandle}
            onKeyPress={this.clickHandle}
            role="button"
            tabIndex="-1"
          >
            {t('header.home')}
          </a>
          <a className="header-new-btn" href="/items/new">
            {t('header.new_ad')}
          </a>
        </div>
      </div>
    );
  }
}

export default withTranslation()(
  withRouter(connect(null, mapDispatchToProps)(Header))
);
